import { createStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    addUserButton: {
      top: '20px',
      marginRight: '30px',
      width: 'auto',
      height: '30px',
    },
  }),
);
